import React from "react";

export const Logo = (
  <svg viewBox="0 0 515.96 115.17">
    <path
      class="cls-1"
      d="M205.4,49.37l-10.64-2.62c-6.3-1.5-9.48-4.49-9.48-8.92,0-5.66,4.79-9.47,11.92-9.47,6.36,0,11.42,3.79,11.79,8.83l.13,1.93h13.61l-.07-2.14c-.53-14.8-13.65-21.54-25.61-21.54-14.93,0-25.78,9.35-25.78,22.23,0,11.37,6.51,18.47,19.91,21.7l10.28,2.46c6.61,1.67,9.82,4.79,9.82,9.54,0,6.22-5.71,10.22-14.54,10.22-9.71,0-14.18-5.61-15.04-10.43l-.31-1.71h-13.07l.2,2.27c1.4,15.66,15.61,22.79,28.22,22.79,16.81,0,28.54-9.46,28.54-22.98,0-6.49-2.59-17.99-19.88-22.16Z"
    />
    <path
      class="cls-2"
      d="M123.88,15.3c-9.39,0-17.79,3.42-24.42,8.91v-6.43h-13.98v97.24h3.45c3.62-.44,6.91-1.58,9.74-3.29.5-.3.79-.85.79-1.44v-25.99c6.63,5.49,15.02,8.88,24.42,8.88,21.53,0,38.4-17.09,38.4-38.89s-16.87-39.01-38.4-39.01ZM123.88,78.24c-12.94,0-23.06-10.51-23.06-23.93s10.12-24.03,23.06-24.03,23.03,10.56,23.03,24.03-10.12,23.93-23.03,23.93Z"
    />
    <path
      class="cls-5"
      d="M425.35,16.3c-8.75,0-15.75,3.94-20.38,11.29v-9.75h-14.15v75.99h14.15v-29.16c0-10.42,1.97-34.69,20.23-34.69,2.02,0,5.19.32,8.89,1.86l2.33.97,2.64-13.41-1.4-.72c-3.45-1.75-8.63-2.39-12.31-2.39Z"
    />
    <path
      class="cls-3"
      d="M501.96,17.63v41.91c-.15,16.06-11.34,21.78-21.77,21.78-11.09,0-18.24-7.94-18.24-20.23V17.63h-14v43.9c-.07,10.42,3.04,19.11,8.98,25.11,5.53,5.56,13.19,8.51,22.17,8.51,7.88,0,17.06-2.91,22.85-9.24v7.7h14V17.63h-14Z"
    />
    <path
      class="cls-7"
      d="M363.71,59.54c-.15,16.06-11.34,21.78-21.77,21.78-11.09,0-18.23-7.94-18.23-20.23V17.63h-14v43.9c-.07,10.42,3.03,19.11,8.98,25.11,5.53,5.56,13.19,8.51,22.17,8.51,7.88,0,17.06-2.91,22.85-9.24v7.7h14V17.63h-14v41.91Z"
    />
    <path
      class="cls-4"
      d="M38.56,14.37C16.94,14.37,0,31.56,0,53.53s16.94,39.04,38.56,39.04,38.56-17.15,38.56-39.04S60.18,14.37,38.56,14.37ZM38.56,77.55c-12.97,0-23.14-10.55-23.14-24.02s10.16-24.13,23.14-24.13,23.14,10.6,23.14,24.13-10.16,24.02-23.14,24.02Z"
    />
    <path
      class="cls-6"
      d="M301.98,49.81c0-19.01-15.41-34.42-34.42-34.42v15.3c10.56,0,19.12,8.56,19.12,19.12s-8.56,19.12-19.12,19.12-19.12-8.56-19.12-19.12h-15.3c0,19.01,15.41,34.42,34.42,34.42s34.42-15.41,34.42-34.42Z"
    />
    <path
      class="cls-6"
      d="M248.66,26.84h-15.46c0-14.82,12.02-26.84,26.84-26.84v15.46c-6.28,0-11.38,5.1-11.38,11.38Z"
    />
    <path
      class="cls-6"
      d="M259.86,115.17c-14.82,0-26.84-12.02-26.84-26.84h15.3c0,6.37,5.17,11.54,11.54,11.54s11.55-5.17,11.55-11.54h15.29c0,14.82-12.02,26.84-26.84,26.84Z"
    />
  </svg>
);

export const LogoPPC = (
  <svg
    width="166"
    height="55"
    viewBox="0 0 166 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_141_11228)">
      <path
        class="cls-11"
        d="M205.4,49.37l-10.64-2.62c-6.3-1.5-9.48-4.49-9.48-8.92,0-5.66,4.79-9.47,11.92-9.47,6.36,0,11.42,3.79,11.79,8.83l.13,1.93h13.61l-.07-2.14c-.53-14.8-13.65-21.54-25.61-21.54-14.93,0-25.78,9.35-25.78,22.23,0,11.37,6.51,18.47,19.91,21.7l10.28,2.46c6.61,1.67,9.82,4.79,9.82,9.54,0,6.22-5.71,10.22-14.54,10.22-9.71,0-14.18-5.61-15.04-10.43l-.31-1.71h-13.07l.2,2.27c1.4,15.66,15.61,22.79,28.22,22.79,16.81,0,28.54-9.46,28.54-22.98,0-6.49-2.59-17.99-19.88-22.16Z"
      />
      <path
        class="cls-1"
        d="M123.88,15.3c-9.39,0-17.79,3.42-24.42,8.91v-6.43h-13.98v97.24h3.45c3.62-.44,6.91-1.58,9.74-3.29.5-.3.79-.85.79-1.44v-25.99c6.63,5.49,15.02,8.88,24.42,8.88,21.53,0,38.4-17.09,38.4-38.89s-16.87-39.01-38.4-39.01v.02ZM123.88,78.24c-12.94,0-23.06-10.51-23.06-23.93s10.12-24.03,23.06-24.03,23.03,10.56,23.03,24.03-10.12,23.93-23.03,23.93Z"
      />
      <path
        class="cls-1"
        d="M425.35,16.3c-8.75,0-15.75,3.94-20.38,11.29v-9.75h-14.15v75.99h14.15v-29.16c0-10.42,1.97-34.69,20.23-34.69,2.02,0,5.19.32,8.89,1.86l2.33.97,2.64-13.41-1.4-.72c-3.45-1.75-8.63-2.39-12.31-2.39h0Z"
      />
      <path
        class="cls-1"
        d="M501.96,17.63v41.91c-.15,16.06-11.34,21.78-21.77,21.78-11.09,0-18.24-7.94-18.24-20.23V17.63h-14v43.9c-.07,10.42,3.04,19.11,8.98,25.11,5.53,5.56,13.19,8.51,22.17,8.51,7.88,0,17.06-2.91,22.85-9.24v7.7h14V17.63h-14,0Z"
      />
      <path
        class="cls-1"
        d="M363.71,59.54c-.15,16.06-11.34,21.78-21.77,21.78-11.09,0-18.23-7.94-18.23-20.23V17.63h-14v43.9c-.07,10.42,3.03,19.11,8.98,25.11,5.53,5.56,13.19,8.51,22.17,8.51,7.88,0,17.06-2.91,22.85-9.24v7.7h14V17.63h-14v41.91h0Z"
      />
      <path
        class="cls-1"
        d="M38.56,14.37C16.94,14.37,0,31.56,0,53.53s16.94,39.04,38.56,39.04,38.56-17.15,38.56-39.04S60.18,14.37,38.56,14.37ZM38.56,77.55c-12.97,0-23.14-10.55-23.14-24.02s10.16-24.13,23.14-24.13,23.14,10.6,23.14,24.13-10.16,24.02-23.14,24.02Z"
      />
      <path
        class="cls-1"
        d="M301.98,49.81c0-19.01-15.41-34.42-34.42-34.42v15.3c10.56,0,19.12,8.56,19.12,19.12s-8.56,19.12-19.12,19.12-19.12-8.56-19.12-19.12h-15.3c0,19.01,15.41,34.42,34.42,34.42s34.42-15.41,34.42-34.42h0Z"
      />
      <path
        class="cls-1"
        d="M248.66,26.84h-15.46c0-14.82,12.02-26.84,26.84-26.84v15.46c-6.28,0-11.38,5.1-11.38,11.38Z"
      />
      <path
        class="cls-1"
        d="M259.86,115.17c-14.82,0-26.84-12.02-26.84-26.84h15.3c0,6.37,5.17,11.54,11.54,11.54s11.55-5.17,11.55-11.54h15.29c0,14.82-12.02,26.84-26.84,26.84Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_141_11228">
        <rect width="166" height="55" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Linkedin = (
  <svg viewBox="0 0 25 25">
    <path d="M2.94 -9.53674e-07C4.56133 -9.53674e-07 5.87867 1.31733 5.87867 2.94C5.87867 4.56267 4.56133 5.88133 2.94 5.88133C1.31467 5.88133 0 4.56267 0 2.94C0 1.31733 1.31467 -9.53674e-07 2.94 -9.53674e-07ZM0.404 8.11067H5.47733V24.4267H0.404V8.11067Z" />
    <path d="M8.6568 8.11133H13.5221V10.3393H13.5915C14.2675 9.05666 15.9235 7.70466 18.3901 7.70466C23.5208 7.70466 24.4688 11.0833 24.4688 15.478V24.4273H19.4035V16.4927C19.4035 14.6007 19.3661 12.166 16.7675 12.166C14.1288 12.166 13.7261 14.2273 13.7261 16.3567V24.4273H8.6568V8.11133Z" />
  </svg>
);

export const Facebook = (
  <svg viewBox="0 0 23 43">
    <path d="M14.598 42.245v-18.89h6.342l.95-7.36h-7.292v-4.7c0-2.132.592-3.584 3.648-3.584h3.9V1.124c-.676-.088-2.989-.29-5.682-.29-5.619 0-9.467 3.431-9.467 9.731v5.43H.641v7.36h6.356v18.889h7.601z" />
  </svg>
);

export const Github = (
  <svg viewBox="0 0 42 41">
    <path d="M21.135.712C9.91.712.807 9.814.807 21.042c0 8.982 5.824 16.602 13.904 19.292 1.016.185 1.387-.442 1.387-.982 0-.482-.018-1.761-.028-3.457-5.655 1.23-6.848-2.724-6.848-2.724-.924-2.35-2.258-2.975-2.258-2.975-1.845-1.261.142-1.234.142-1.234 2.04.142 3.112 2.094 3.112 2.094 1.814 3.107 4.758 2.21 5.917 1.688.185-1.313.71-2.21 1.29-2.717-4.514-.512-9.26-2.257-9.26-10.048 0-2.219.793-4.033 2.094-5.455-.21-.513-.908-2.581.199-5.38 0 0 1.706-.546 5.59 2.084 1.62-.45 3.36-.676 5.09-.684 1.726.008 3.465.234 5.089.684 3.88-2.63 5.585-2.084 5.585-2.084 1.11 2.799.411 4.867.202 5.38 1.304 1.422 2.09 3.236 2.09 5.455 0 7.81-4.753 9.53-9.282 10.032.73.627 1.38 1.868 1.38 3.765 0 2.718-.026 4.91-.026 5.576 0 .544.367 1.176 1.399.979 8.072-2.695 13.89-10.31 13.89-19.288 0-11.23-9.102-20.33-20.33-20.33z" />
  </svg>
);

export const Pin = (
  <svg viewBox="0 0 140 94" fill="none">
    <g clipPath="url(#clip0)">
      <path
        d="M82 63.6999C93.1 68.6999 110.9 88.2999 115.5 92.9999C119 94.0999 -47.4 20.7999 13.4 33.9999C32.4 39.4999 63.1 52.7999 82 63.6999ZM70.4 66.9999C108 75.2999 26.4 37.7999 21.6 38.7999C8.00001 34.8999 8.00001 37.9999 21.4 45.7999C34.9 53.5999 56.8 63.0999 70.4 66.9999Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M131.754 22C130.754 17 115.954 11.5 112.354 8.69995C126.754 20.8 106.654 56.2 88.4536 49.7999C91.2536 51.0999 101.805 60.0134 107.354 59.7C125.054 58.7 135.854 37 131.754 22Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M118.4 10.5C122.7 8.59996 127.9 7.89996 132.2 10.4C131.7 10.2 115.7 0.699962 115.7 0.899962C110.6 -1.10004 105.1 0.3 100.5 3L115.4 12.1C116.4 11.4 117.4 10.9 118.4 10.5Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M93.9999 61.9999C87.1999 45.2999 100.6 20.4999 115.5 11.9999L100.5 2.99988C84.8999 12.7999 72.1999 35.1 78.4999 53.3C81.3999 59.9 99.4999 83.1 100.5 84.3L115.6 93.1C115 90.4999 96.8999 68.5999 93.9999 61.9999Z"
        fill="url(#paint3_linear)"
      />
      <path
        d="M115.4 12C128.4 4.49996 139.1 10.5 139.1 25.5C139.4 40.1 117.9 85.5 115.6 93C112.6 87.8 91.8 66.9999 91.8 52.7C91.8 37.8 102.3 19.5 115.4 12ZM115.5 57.3C124.8 51.9 132.3 38.9 132.3 28.2C132.3 17.5 124.7 13.2 115.4 18.6C106.1 24 98.6 37 98.6 47.7C98.6 58.3 106.2 62.6 115.5 57.3Z"
        fill="url(#paint4_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="11.0487"
        y1="32.4382"
        x2="11.0487"
        y2="93.0597"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.4351" stopColor="#B8C0CC" stopOpacity="0.4" />
        <stop offset="1" stopColor="#005B78" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="97.9229"
        y1="47.6441"
        x2="141.466"
        y2="8.64128"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#734E6F" />
        <stop offset="0.0921788" stopColor="#996893" />
        <stop offset="0.1844" stopColor="#C485BD" />
        <stop offset="1" stopColor="#734E6F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="108.538"
        y1="10.3062"
        x2="137.467"
        y2="-3.13018"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0614525" stopColor="#C485BD" />
        <stop offset="0.919" stopColor="#734E6F" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="95.298"
        y1="6.78807"
        x2="98.4629"
        y2="90.1288"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0614525" stopColor="#C485BD" />
        <stop offset="0.919" stopColor="#734E6F" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="91.7475"
        y1="50.9066"
        x2="139.066"
        y2="50.9066"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ECADED" />
        <stop offset="1" stopColor="#AE78B0" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="139.1" height="93.1" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Burger = (
  <svg viewBox="0 0 19 17">
    <rect width="19" height="3" rx="1.5" />
    <rect y="7" width="19" height="3" rx="1.5" />
    <rect y="14" width="19" height="3" rx="1.5" />
  </svg>
);

export const X = (
  <svg viewBox="0 0 26 24">
    <rect
      x="2.603"
      y=".085"
      width="30.1"
      height="3.681"
      rx="1.84"
      transform="rotate(45 2.603 .085)"
    />
    <rect
      x="25.118"
      y="2.716"
      width="30.1"
      height="3.841"
      rx="1.921"
      transform="rotate(135 25.118 2.716)"
    />
  </svg>
);

export const ArrowDown = (
  <svg viewBox="0 0 19 13">
    <path d="M11.06 12.054a2 2 0 01-3.12 0L1.282 3.751C.232 2.442 1.164.5 2.842.5h13.316c1.678 0 2.61 1.942 1.56 3.251l-6.658 8.303z" />
  </svg>
);

export const DoubleArrowRight = (
  <svg viewBox="0 0 38 23" fill="none">
    <rect
      x="2.43"
      width="21.02"
      height="4.86"
      rx="2.43"
      transform="rotate(30 2.43 0)"
      fill="#fff"
    />
    <rect
      width="21.02"
      height="4.86"
      rx="2.43"
      transform="scale(1 -1) rotate(30 44.014 -6.933)"
      fill="#fff"
    />
    <rect
      x="19.111"
      width="21.02"
      height="4.86"
      rx="2.43"
      transform="rotate(30 19.11 0)"
      fill="#fff"
    />
    <rect
      width="21.02"
      height="4.86"
      rx="2.43"
      transform="scale(1 -1) rotate(30 52.355 24.193)"
      fill="#fff"
    />
  </svg>
);

export const ArrowSubMenu = (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1L4.0089 4L7 1" fill="white" />
    <path
      d="M1 1L4.0089 4L7 1"
      stroke="#00AECA"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
);

export const SingleArrowRight = (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.688965 8.78467L5.2852 4.78595L0.688964 0.741263"
      stroke="#00AECA"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
);

export const LogoCarbon60 = (
  <svg viewBox="0 0 420.6 79.4">
    <g>
      <path
        class="st0"
        fill="#ffffff"
        d="M1,67.1c-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.6s0.3-0.2,0.6-0.2h9.4
			c0.2,0,0.4,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.6,0.2H1z M5.7,79.1
			c-0.2,0-0.4-0.1-0.6-0.2s-0.2-0.4-0.2-0.6V65.6h1.6v12.7c0,0.2-0.1,0.4-0.2,0.6S6,79.1,5.7,79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M18.1,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.6v5.1h8.2v-5.1c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2
			s0.4,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.6v11.9c0,0.2-0.1,0.4-0.2,0.6s-0.3,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2
			c-0.2-0.2-0.2-0.4-0.2-0.6V73h-8.2v5.3c0,0.2-0.1,0.4-0.2,0.6C18.6,79,18.4,79.1,18.1,79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M37.2,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2h7.9c0.2,0,0.4,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.2-0.1,0.4-0.2,0.5s-0.3,0.2-0.6,0.2H38v4.4h5.1
			c0.2,0,0.4,0.1,0.6,0.2s0.2,0.3,0.2,0.6c0,0.2-0.1,0.4-0.2,0.5S43.4,73,43.1,73H38v4.5h7.1c0.2,0,0.4,0.1,0.6,0.2
			c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.6c-0.1,0.1-0.3,0.2-0.6,0.2h-7.9V79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M62.7,79.1c-0.2,0-0.4-0.1-0.6-0.2s-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2
			c0.3,0,0.6,0.1,0.7,0.4L69,77.1h-0.6L73.8,66c0.2-0.3,0.4-0.4,0.7-0.4c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6v11.9
			c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.4,0.2-0.6,0.2s-0.4-0.1-0.6-0.2s-0.2-0.4-0.2-0.6v-9.6l0.3-0.1l-4.7,9.6
			c-0.2,0.3-0.4,0.4-0.7,0.4c-0.3,0-0.6-0.2-0.8-0.5l-4.7-9.4l0.3-0.1v9.6c0,0.2-0.1,0.4-0.2,0.6C63.1,79,62.9,79.1,62.7,79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M82.4,79.1c-0.3,0-0.5-0.1-0.7-0.4s-0.2-0.5,0-0.8l4.9-11.8c0.2-0.4,0.4-0.6,0.8-0.6c0.4,0,0.6,0.2,0.8,0.6
			l5,11.8c0.1,0.3,0.1,0.6-0.1,0.8s-0.4,0.4-0.7,0.4c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.2-0.3-0.4l-4.4-11h0.5l-4.5,11
			c-0.1,0.2-0.2,0.3-0.3,0.4C82.7,79.1,82.5,79.1,82.4,79.1z M83.4,76.1l0.6-1.4h6.9l0.6,1.4H83.4z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M100.1,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.3-0.2,0.6-0.2s0.5,0.1,0.6,0.3l7.8,10.3v-9.8c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.3-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2
			c0.1,0.2,0.2,0.4,0.2,0.6v11.9c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.3,0.2-0.6,0.2c-0.1,0-0.2,0-0.3-0.1s-0.2-0.1-0.3-0.2l-7.8-10.3
			v9.8c0,0.2-0.1,0.4-0.2,0.6C100.5,79,100.3,79.1,100.1,79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M117.2,79.1c-0.3,0-0.5-0.1-0.7-0.4s-0.2-0.5,0-0.8l4.9-11.8c0.2-0.4,0.4-0.6,0.8-0.6c0.4,0,0.6,0.2,0.8,0.6
			l5,11.8c0.1,0.3,0.1,0.6-0.1,0.8s-0.4,0.4-0.7,0.4c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.2-0.3-0.4l-4.4-11h0.5l-4.5,11
			c-0.1,0.2-0.2,0.3-0.3,0.4C117.5,79.1,117.3,79.1,117.2,79.1z M118.2,76.1l0.6-1.4h6.9l0.6,1.4H118.2z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M139.8,79.3c-0.9,0-1.8-0.2-2.6-0.5c-0.8-0.4-1.5-0.8-2.1-1.5c-0.6-0.6-1.1-1.4-1.4-2.2
			c-0.3-0.8-0.5-1.7-0.5-2.7s0.2-1.9,0.5-2.7c0.3-0.8,0.8-1.6,1.4-2.2c0.6-0.6,1.3-1.1,2.1-1.5s1.7-0.5,2.6-0.5
			c0.9,0,1.6,0.1,2.3,0.4s1.3,0.6,1.9,1.2c0.1,0.1,0.2,0.1,0.2,0.2s0.1,0.2,0.1,0.3s0,0.2,0,0.3c0,0.2-0.1,0.3-0.2,0.4
			c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2c-0.4-0.4-0.9-0.7-1.4-0.9c-0.5-0.2-1.1-0.3-1.8-0.3s-1.4,0.1-2,0.4s-1.2,0.7-1.6,1.2
			s-0.8,1.1-1.1,1.7c-0.3,0.7-0.4,1.3-0.4,2.1c0,0.8,0.1,1.5,0.4,2.1c0.3,0.7,0.6,1.2,1.1,1.7s1,0.9,1.6,1.2c0.6,0.3,1.3,0.4,2,0.4
			c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1.1-0.5,1.5-0.9c0.2-0.1,0.4-0.2,0.6-0.2s0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5
			c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.6,0.5-1.3,0.9-2,1.1C141.3,79.2,140.6,79.3,139.8,79.3z M144.3,77.2l-1.6-0.3v-3.2
			h-2.5c-0.2,0-0.4-0.1-0.6-0.2s-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.2-0.1,0.4-0.2,0.6-0.2h3.3c0.2,0,0.4,0.1,0.6,0.2
			c0.1,0.2,0.2,0.3,0.2,0.6V77.2z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M152.1,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2h7.9c0.2,0,0.4,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.2-0.1,0.4-0.2,0.5s-0.3,0.2-0.6,0.2h-7.1v4.4h5.1
			c0.2,0,0.4,0.1,0.6,0.2s0.2,0.3,0.2,0.6c0,0.2-0.1,0.4-0.2,0.5S158.3,73,158,73h-5.1v4.5h7.1c0.2,0,0.4,0.1,0.6,0.2
			c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.6c-0.1,0.1-0.3,0.2-0.6,0.2h-7.9V79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M168.4,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2h3.1c1,0,1.9,0.2,2.7,0.5s1.5,0.8,2.1,1.4s1.1,1.3,1.4,2.1c0.3,0.8,0.5,1.7,0.5,2.7s-0.2,1.9-0.5,2.7
			c-0.3,0.8-0.8,1.5-1.4,2.1c-0.6,0.6-1.3,1.1-2.1,1.4s-1.7,0.5-2.7,0.5L168.4,79.1L168.4,79.1z M169.2,77.7h2.3c1,0,1.9-0.2,2.7-0.7
			s1.4-1.1,1.8-1.9c0.4-0.8,0.7-1.7,0.7-2.7s-0.2-2-0.7-2.7s-1-1.4-1.8-1.9s-1.7-0.7-2.7-0.7h-2.3V77.7z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M200.5,79.3c-0.9,0-1.8-0.2-2.6-0.5c-0.8-0.4-1.5-0.8-2.1-1.5c-0.6-0.6-1.1-1.4-1.4-2.2
			c-0.3-0.8-0.5-1.7-0.5-2.7s0.2-1.9,0.5-2.7c0.3-0.8,0.8-1.6,1.4-2.2c0.6-0.6,1.3-1.1,2.1-1.5s1.7-0.5,2.6-0.5
			c0.9,0,1.6,0.1,2.3,0.4c0.7,0.2,1.3,0.6,1.9,1.2c0.1,0.1,0.2,0.1,0.2,0.2s0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.3-0.2,0.4
			c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2c-0.4-0.4-0.9-0.7-1.4-0.9s-1.1-0.3-1.8-0.3s-1.4,0.1-2,0.4s-1.2,0.7-1.6,1.2
			c-0.5,0.5-0.8,1.1-1.1,1.7c-0.3,0.7-0.4,1.3-0.4,2.1c0,0.8,0.1,1.5,0.4,2.1c0.3,0.7,0.6,1.2,1.1,1.7s1,0.9,1.6,1.2
			c0.6,0.3,1.3,0.4,2,0.4c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1.1-0.5,1.5-0.9c0.2-0.1,0.4-0.2,0.6-0.2s0.3,0.1,0.5,0.2
			c0.1,0.1,0.2,0.3,0.2,0.5c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.6,0.5-1.3,0.9-2,1.1C202,79.2,201.2,79.3,200.5,79.3z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M212.8,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6v11.1h6.4c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.3,0.2,0.6
			s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2C220,79.1,212.8,79.1,212.8,79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M232.2,79.3c-1,0-1.9-0.2-2.8-0.5c-0.8-0.3-1.6-0.8-2.2-1.4s-1.1-1.4-1.4-2.2c-0.3-0.8-0.5-1.8-0.5-2.8
			s0.2-1.9,0.5-2.8c0.3-0.8,0.8-1.6,1.4-2.2s1.3-1.1,2.2-1.4c0.8-0.3,1.8-0.5,2.8-0.5s1.9,0.2,2.8,0.5c0.8,0.3,1.6,0.8,2.2,1.4
			s1.1,1.4,1.4,2.2c0.3,0.8,0.5,1.8,0.5,2.8s-0.2,1.9-0.5,2.8c-0.3,0.8-0.8,1.6-1.4,2.2s-1.3,1.1-2.2,1.4
			C234.1,79.1,233.2,79.3,232.2,79.3z M232.2,77.8c0.8,0,1.5-0.1,2.1-0.4s1.2-0.7,1.7-1.2s0.8-1.1,1.1-1.7c0.3-0.7,0.4-1.4,0.4-2.1
			c0-0.8-0.1-1.5-0.4-2.1c-0.3-0.7-0.6-1.2-1.1-1.7s-1-0.9-1.7-1.1c-0.6-0.3-1.4-0.4-2.1-0.4c-0.8,0-1.5,0.1-2.1,0.4
			s-1.2,0.7-1.7,1.1c-0.5,0.5-0.8,1.1-1.1,1.7c-0.3,0.7-0.4,1.4-0.4,2.1c0,0.8,0.1,1.5,0.4,2.1c0.3,0.7,0.6,1.2,1.1,1.7
			s1,0.9,1.7,1.2C230.7,77.7,231.4,77.8,232.2,77.8z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M251.6,79.4c-1.1,0-2-0.2-2.9-0.6c-0.8-0.4-1.5-1-2-1.7s-0.7-1.5-0.7-2.5v-8.2c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.6v8.2c0,0.6,0.2,1.2,0.5,1.7s0.8,0.9,1.4,1.2
			c0.6,0.3,1.3,0.4,2,0.4s1.4-0.1,2-0.4s1-0.7,1.3-1.2s0.5-1.1,0.5-1.7v-8.2c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.3-0.2,0.6-0.2
			c0.3,0,0.5,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.6v8.2c0,0.9-0.2,1.8-0.7,2.5c-0.5,0.7-1.1,1.3-1.9,1.7
			C253.6,79.2,252.7,79.4,251.6,79.4z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M265.5,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2h3.1c1,0,1.9,0.2,2.7,0.5s1.5,0.8,2.1,1.4s1.1,1.3,1.4,2.1c0.3,0.8,0.5,1.7,0.5,2.7s-0.2,1.9-0.5,2.7
			c-0.3,0.8-0.8,1.5-1.4,2.1s-1.3,1.1-2.1,1.4s-1.7,0.5-2.7,0.5L265.5,79.1L265.5,79.1z M266.3,77.7h2.3c1,0,1.9-0.2,2.7-0.7
			c0.8-0.5,1.4-1.1,1.8-1.9s0.7-1.7,0.7-2.7s-0.2-2-0.7-2.7s-1-1.4-1.8-1.9s-1.7-0.7-2.7-0.7h-2.3V77.7z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M297.6,79.3c-0.9,0-1.8-0.2-2.6-0.5c-0.8-0.4-1.5-0.8-2.1-1.5c-0.6-0.6-1.1-1.4-1.4-2.2
			c-0.3-0.8-0.5-1.7-0.5-2.7s0.2-1.9,0.5-2.7c0.3-0.8,0.8-1.6,1.4-2.2s1.3-1.1,2.1-1.5c0.8-0.4,1.7-0.5,2.6-0.5s1.6,0.1,2.3,0.4
			c0.7,0.2,1.3,0.6,1.9,1.2c0.1,0.1,0.2,0.1,0.2,0.2s0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.3-0.2,0.4s-0.3,0.2-0.5,0.2
			s-0.4-0.1-0.5-0.2c-0.4-0.4-0.9-0.7-1.4-0.9s-1.1-0.3-1.8-0.3c-0.7,0-1.4,0.1-2,0.4s-1.2,0.7-1.6,1.2c-0.5,0.5-0.8,1.1-1.1,1.7
			c-0.3,0.7-0.4,1.3-0.4,2.1c0,0.8,0.1,1.5,0.4,2.1c0.3,0.7,0.6,1.2,1.1,1.7s1,0.9,1.6,1.2c0.6,0.3,1.3,0.4,2,0.4
			c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1.1-0.5,1.5-0.9c0.2-0.1,0.4-0.2,0.6-0.2s0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5
			c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.6,0.5-1.3,0.9-2,1.1C299.1,79.2,298.4,79.3,297.6,79.3z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M315.4,79.3c-1,0-1.9-0.2-2.8-0.5c-0.8-0.3-1.6-0.8-2.2-1.4s-1.1-1.4-1.4-2.2c-0.3-0.8-0.5-1.8-0.5-2.8
			s0.2-1.9,0.5-2.8c0.3-0.8,0.8-1.6,1.4-2.2s1.3-1.1,2.2-1.4c0.8-0.3,1.8-0.5,2.8-0.5s1.9,0.2,2.8,0.5c0.8,0.3,1.6,0.8,2.2,1.4
			s1.1,1.4,1.4,2.2c0.3,0.8,0.5,1.8,0.5,2.8s-0.2,1.9-0.5,2.8c-0.3,0.8-0.8,1.6-1.4,2.2s-1.3,1.1-2.2,1.4
			C317.3,79.1,316.4,79.3,315.4,79.3z M315.4,77.8c0.8,0,1.5-0.1,2.1-0.4s1.2-0.7,1.7-1.2s0.8-1.1,1.1-1.7c0.3-0.7,0.4-1.4,0.4-2.1
			c0-0.8-0.1-1.5-0.4-2.1c-0.3-0.7-0.6-1.2-1.1-1.7s-1-0.9-1.7-1.1c-0.6-0.3-1.4-0.4-2.1-0.4c-0.8,0-1.5,0.1-2.1,0.4
			s-1.2,0.7-1.7,1.1c-0.5,0.5-0.8,1.1-1.1,1.7c-0.3,0.7-0.4,1.4-0.4,2.1c0,0.8,0.1,1.5,0.4,2.1c0.3,0.7,0.6,1.2,1.1,1.7
			s1,0.9,1.7,1.2C313.9,77.7,314.6,77.8,315.4,77.8z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M330,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2c0.3,0,0.6,0.1,0.7,0.4l5.6,11.1h-0.6l5.4-11.1c0.2-0.3,0.4-0.4,0.7-0.4c0.2,0,0.4,0.1,0.6,0.2
			c0.2,0.2,0.2,0.4,0.2,0.6v11.9c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2s-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6v-9.6
			l0.3-0.1l-4.7,9.6c-0.2,0.3-0.4,0.4-0.7,0.4c-0.3,0-0.6-0.2-0.8-0.5l-4.7-9.4l0.3-0.1v9.6c0,0.2-0.1,0.4-0.2,0.6
			C330.5,79,330.3,79.1,330,79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M351.2,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.4-0.2,0.6-0.2h3.5c0.9,0,1.6,0.2,2.3,0.6s1.2,0.9,1.6,1.6s0.6,1.4,0.6,2.3s-0.2,1.6-0.6,2.3s-0.9,1.2-1.6,1.5
			c-0.7,0.4-1.4,0.6-2.3,0.6h-2.6v3.9c0,0.2-0.1,0.4-0.2,0.6C351.6,79,351.4,79.1,351.2,79.1z M352,72.9h2.6c0.5,0,1-0.1,1.5-0.4
			s0.8-0.6,1-1s0.4-0.9,0.4-1.5s-0.1-1.1-0.4-1.5c-0.2-0.4-0.6-0.8-1-1s-0.9-0.4-1.5-0.4H352V72.9z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M364.1,79.1c-0.3,0-0.5-0.1-0.7-0.4s-0.2-0.5,0-0.8l4.9-11.8c0.2-0.4,0.4-0.6,0.8-0.6s0.6,0.2,0.8,0.6l5,11.8
			c0.1,0.3,0.1,0.6-0.1,0.8c-0.2,0.2-0.4,0.4-0.7,0.4c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.2-0.3-0.4l-4.4-11h0.5l-4.5,11
			c-0.1,0.2-0.2,0.3-0.3,0.4S364.2,79.1,364.1,79.1z M365.1,76.1l0.6-1.4h6.9l0.6,1.4H365.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M381.8,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V66.4c0-0.2,0.1-0.4,0.2-0.6
			c0.2-0.2,0.3-0.2,0.6-0.2c0.3,0,0.5,0.1,0.6,0.3l7.8,10.3v-9.8c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.3-0.2,0.6-0.2
			c0.2,0,0.4,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.6v11.9c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.3,0.2-0.6,0.2c-0.1,0-0.2,0-0.3-0.1
			s-0.2-0.1-0.3-0.2l-7.8-10.3v9.8c0,0.2-0.1,0.4-0.2,0.6C382.3,79,382.1,79.1,381.8,79.1z"
      />
      <path
        class="st0"
        fill="#ffffff"
        d="M403.5,79.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6v-4.1l-4.7-7.3c-0.1-0.2-0.2-0.4-0.2-0.6
			s0.1-0.4,0.3-0.5c0.1-0.1,0.3-0.2,0.5-0.2s0.3,0,0.4,0.1s0.2,0.2,0.3,0.3l4.5,7.1h-0.7l4.5-7.2c0.1-0.1,0.2-0.2,0.3-0.3
			c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5s0,0.4-0.2,0.6l-4.7,7.3v4.1c0,0.2-0.1,0.4-0.2,0.6
			C403.9,79,403.7,79.1,403.5,79.1z"
      />
    </g>
    <g>
      <path
        class="st1"
        fill="#ffffff"
        d="M44.7,30.8c-0.1-0.2-0.2-0.3-0.4-0.3c-0.2,0-0.3,0-0.5,0.1c-6.6,4.3-10.3,5.8-17.9,5.8
			c-7.9,0-16.3-4.6-16.3-13.2c0-8.3,8.2-13.4,15.9-13.4c6.1,0,10.8,2,16.3,6.8c0.1,0.1,0.3,0.2,0.5,0.1c0.2,0,0.3-0.1,0.4-0.3l5-7.4
			c0.2-0.3,0.1-0.6-0.1-0.8C40.2,2.7,34.8,0,25.7,0C11,0,0,10.1,0,23.5C0,39,13.7,46,26.5,46c9.5,0,13.8-1.7,21.8-6.7
			c0.3-0.2,0.4-0.5,0.2-0.8L44.7,30.8z"
      />
      <path
        class="st1"
        fill="#ffffff"
        d="M88.3,1.7c-0.1-0.2-0.3-0.3-0.5-0.3H76.6c-0.2,0-0.4,0.1-0.5,0.3L55.7,43.8c-0.1,0.2-0.1,0.4,0,0.6
			s0.3,0.3,0.5,0.3h9.6c0.2,0,0.4-0.1,0.5-0.3l15.9-32.8l7.2,14.7h-9.3c-0.2,0-0.4,0.1-0.5,0.3l-4,8.4c-0.1,0.2-0.1,0.4,0,0.6
			c0.1,0.2,0.3,0.3,0.5,0.3h18.1l4.1,8.5c0.1,0.2,0.3,0.3,0.5,0.3h9.6c0.2,0,0.4-0.1,0.5-0.3c0.1-0.2,0.1-0.4,0-0.6L88.3,1.7z"
      />
      <path
        class="st1"
        fill="#ffffff"
        d="M154.7,27.2c6-2.1,9.1-6.5,9.1-12.5c0-4.4-2-8.5-5.4-10.9c-2.8-2-5.2-2.4-8.4-2.4h-28.8
			c-0.3,0-0.6,0.3-0.6,0.6v42.1c0,0.3,0.3,0.6,0.6,0.6h8.5c0.3,0,0.6-0.3,0.6-0.6V27.4h12.5l10.5,16.9c0.1,0.2,0.3,0.3,0.5,0.3h10.6
			l0,0c0.3,0,0.6-0.3,0.6-0.6c0-0.2-0.1-0.3-0.2-0.4L154.7,27.2z M130.3,11h18.2c3.5,0,5.6,0.6,5.6,3.4c0,2.6-2.2,3.5-4.1,3.5h-19.6
			L130.3,11L130.3,11z"
      />
      <path
        class="st1"
        fill="#ffffff"
        d="M218.1,21c2.1-2.5,2.6-4.2,2.6-7.6c0-3.4-1.3-6.7-3.6-8.9c-2.9-2.9-6.2-3.1-9.8-3.1h-27.5
			c-0.3,0-0.6,0.3-0.6,0.6v42.1c0,0.3,0.3,0.6,0.6,0.6h27.5c9.6,0,15.5-5.3,15.5-13.8C222.8,26.6,221.6,23.9,218.1,21z M188.8,26.6
			h18.5c4.2,0,6,1.2,6,4.1c0,3-1.8,4.3-6,4.3h-18.5V26.6z M207.3,17.1h-18.5v-6h18.5c2.7,0,3.6,0.8,3.6,2.9
			C210.9,16.6,210.1,17.1,207.3,17.1z"
      />
      <path
        class="st1"
        fill="#ffffff"
        d="M260.3,0c-12.8,0-26.4,8-26.4,22.9c0,15.1,13.6,23.2,26.3,23.2c12.9,0,26.6-8.2,26.6-23.4
			C286.8,7.1,273.1,0,260.3,0z M260.5,36.2c-8.1,0-16.9-4.1-16.9-13.2S252,9.8,260.4,9.8c8,0,16.7,4,16.7,12.9
			C277.1,31.5,268.6,36.2,260.5,36.2z"
      />
      <path
        class="st1"
        fill="#ffffff"
        d="M342.1,1.4h-8.4c-0.3,0-0.6,0.3-0.6,0.6v26.8L310.8,1.7c-0.1-0.1-0.3-0.2-0.5-0.2h-8.4c-0.3,0-0.6,0.3-0.6,0.6
			v42.1c0,0.3,0.3,0.6,0.6,0.6h8.4c0.3,0,0.6-0.3,0.6-0.6v-27l22.3,27.2c0.1,0.1,0.3,0.2,0.5,0.2h8.4c0.3,0,0.6-0.3,0.6-0.6V2
			C342.7,1.6,342.4,1.4,342.1,1.4z"
      />
    </g>
    <g>
      <path
        class="st2"
        fill="#ffffff"
        d="M371.8,22c-0.8,0-1.4,0.1-2,0.2l7-9.6c0.1-0.2,0.2-0.4,0-0.6c-0.1-0.2-0.3-0.3-0.5-0.3h-8.2
			c-0.2,0-0.4,0.1-0.5,0.3l-7.8,11.3c-2.1,3-3.2,6.5-3.2,9.9c0,7.1,5.2,11.8,13,11.8c7.2,0,12.7-5.1,12.7-11.8
			C382.3,25.5,376.8,22,371.8,22z M373.6,33.3c0,2.5-1.7,4.3-4.1,4.3c-3.7,0-4.1-3.1-4.1-4.4c0-2.6,1.6-4.3,4.1-4.3
			C372,29,373.6,30.6,373.6,33.3z"
      />
      <path
        class="st3"
        fill="#ffffff"
        d="M398.7,11c-7.7,0-12.9,4.8-12.9,11.9v10.3c0,7.1,5.2,11.9,12.9,11.9c7.7,0,12.9-4.8,12.9-11.9V22.8
			C411.7,15.8,406.5,11,398.7,11z M394.7,22.8c0-2.9,1.4-4.4,4.1-4.4s4.1,1.5,4.1,4.4v10.3c0,2.9-1.4,4.4-4.1,4.4s-4.1-1.5-4.1-4.4
			V22.8z"
      />
    </g>
    <g>
      <path
        class="st0"
        fill="#ffffff"
        d="M416.7,46.1c-2.2,0-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9c2.2,0,3.9,1.7,3.9,3.9
			C420.6,44.5,418.9,46.1,416.7,46.1z M416.7,39c-1.8,0-3.3,1.4-3.3,3.3c0,1.8,1.4,3.3,3.3,3.3s3.3-1.4,3.3-3.3
			C420,40.4,418.6,39,416.7,39z M417.5,44.5l-0.9-1.8h-0.4v1.8h-0.9V40h1.6c1,0,1.6,0.5,1.6,1.4s-0.6,1.2-0.9,1.3l1.1,1.9h-1.2V44.5z
			 M416.6,40.8h-0.5v1.3h0.5c0.4,0,0.8-0.1,0.8-0.6C417.5,40.9,417.1,40.8,416.6,40.8z"
      />
    </g>
  </svg>
);
